// extracted by mini-css-extract-plugin
module.exports = {"divider":"MakePaymentPageView_divider__qnlY0","select":"MakePaymentPageView_select__kPhKv","selectLabel":"MakePaymentPageView_selectLabel__2d9Gc"};